<div class="p-2 busy-overlay-parent" [ngClass]="isLoading?'disabled':''">

    <div *ngIf="isLoading || bSyncing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Syncing Markets...
    </div>

    <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
        {{errorMsg}}
        <div role="button" (click)="errorMsg=''"><i class="fa fa-times"></i></div>
    </div>

    <div *fesListView="let filteredMarkets of markets">
        <h5>Markets</h5>
        <div class="d-flex">
            <a href="javascript:false;" (click)="loadMarkets()"><i class="fas fa-sync"></i>&nbsp;Refresh</a>
        </div>
        <table class="table table-striped table-bordered table-sm">
            <thead>
            <tr>
                <th fesSortField="name">Name</th>
                <th fesSortField="description">Timezone</th>
                <th class="text-center align-middle">
                    <button class="btn btn-secondary add-btn" (click)="editMarket()"> Add</button>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>
                    <input fesFilterField="name" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="description" class="small w-100"/>
                </td>
                <td></td>
            </tr>
            <tr *ngFor="let market of filteredMarkets;">
                <td>{{market.name}}</td>
                <td>{{market.description}}</td>
                <td class="text-center align-middle text-nowrap">
                    <div class="flex flex-row">
                        <a class="mr-1" href="javascript:false;" (click)="editMarket(market)">edit</a>
                        <div class="btn-group p-0 m-0" dropdown>
                            <a id="edit-options-btn" href="javascript:false;" behavior="button" dropdownToggle
                               class="dropdown-toggle" aria-controls="dropdown-edit-options">
                                <span class="caret"></span>
                            </a>
                            <ul style="z-index:9999999;min-width:3rem;" id="dropdown-edit-options" *dropdownMenu
                                class="p-2 dropdown-menu dropdown-menu-right" role="menu"
                                aria-labelledby="edit-options-btn">
                                <li role="menuitem"><button class="btn btn-danger"
                                                            (click)="deleteMarket(market)">delete</button></li>
                            </ul>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

</div>
